import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-settlementtracker',
  templateUrl: './settlementtracker.component.html',
  styleUrls: ['./settlementtracker.component.css']
})
export class SettlementtrackerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
